module.exports = __webpack_public_path__ + "static/img/200118.98817635.png";